import { render } from "./DelModal.vue?vue&type=template&id=3c74be9e&ts=true"
import script from "./DelModal.vue?vue&type=script&lang=ts"
export * from "./DelModal.vue?vue&type=script&lang=ts"

import "./DelModal.vue?vue&type=style&index=0&id=3c74be9e&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__